/**
 * CDK Configuration Helper for TimeLynxx Admin Portal
 * Hardcoded environment configuration to bypass Vite env variable issues
 */

import { envLog } from '../config/environment';

export interface CDKConfig {
  region: string;
  cognito: {
    userPoolId: string;
    userPoolClientId: string;
    identityPoolId?: string;
  };
  graphql: {
    endpoint: string;
    region: string;
    authenticationType: string;
  };
}

/**
 * Environment-specific CDK configuration using hostname detection
 */
function createCDKConfig(): CDKConfig {
  // Detect environment from hostname
  const hostname = window.location.hostname;
  
  let config: CDKConfig;
  
  if (hostname === 'admin-dev.timelynxx.com' || hostname === 'localhost') {
    // Development configuration
    config = {
      region: 'us-east-1',
      cognito: {
        userPoolId: 'us-east-1_Ccku08NRu',
        userPoolClientId: '421ncpigg7irbcqiku7c7iq8jd',
      },
      graphql: {
        endpoint: 'https://kit2sdyrcvhrbbf3ws766hkc2i.appsync-api.us-east-1.amazonaws.com/graphql',
        region: 'us-east-1',
        authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      },
    };
  } else if (hostname === 'admin-test.timelynxx.com') {
    // Test configuration
    config = {
      region: 'us-east-1',
      cognito: {
        userPoolId: 'us-east-1_99ohVWxvx',
        userPoolClientId: '216onb8hmraejnvhrvmpfbc5ul',
      },
      graphql: {
        endpoint: 'https://vjrsgqbx65g7dlpwwrf4nrfzby.appsync-api.us-east-1.amazonaws.com/graphql',
        region: 'us-east-1',
        authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      },
    };
  } else if (hostname === 'admin.timelynxx.com') {
    // Production configuration
    config = {
      region: 'us-east-1',
      cognito: {
        userPoolId: 'us-east-1_zwhNUi5nK',
        userPoolClientId: '7uvgldfv68a72lscert6sa1cf9',
      },
      graphql: {
        endpoint: 'https://3peg2wz47jdqbprlxjedxda5i4.appsync-api.us-east-1.amazonaws.com/graphql',
        region: 'us-east-1',
        authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      },
    };
  } else {
    // Default to development for unknown hostnames
    config = {
      region: 'us-east-1',
      cognito: {
        userPoolId: 'us-east-1_Ccku08NRu',
        userPoolClientId: '421ncpigg7irbcqiku7c7iq8jd',
      },
      graphql: {
        endpoint: 'https://kit2sdyrcvhrbbf3ws766hkc2i.appsync-api.us-east-1.amazonaws.com/graphql',
        region: 'us-east-1',
        authenticationType: 'AMAZON_COGNITO_USER_POOLS',
      },
    };
  }

  // Environment-specific logging
  envLog.info('CDK configuration created', {
    hostname: hostname,
    detectedEnvironment: hostname.includes('test') ? 'test' : hostname.includes('admin.') ? 'production' : 'development',
    userPoolId: config.cognito.userPoolId,
    apiEndpoint: config.graphql.endpoint,
    region: config.region,
  });

  return config;
}

export const cdkConfig = createCDKConfig();